var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-stage',[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"基本信息"}},[_c('AdminFormPage',{attrs:{"module":_setup.modulePath,"id":_vm.vId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }